import { render, staticRenderFns } from "./UgcDetails.vue?vue&type=template&id=40af8b60"
import script from "./UgcDetails.vue?vue&type=script&lang=js"
export * from "./UgcDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports